import { render, staticRenderFns } from "./ImportLeavesCompleted.vue?vue&type=template&id=6ae26e94"
import script from "./ImportLeavesCompleted.vue?vue&type=script&lang=js"
export * from "./ImportLeavesCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports